import * as types from './mutation-types'
import api from "@/modules/api";

const actions = {
  async registerCompany({ commit }, data) {
    try {
      commit(types.REGISTER_COMPANY_BEGIN)
      await api.signup.registerNewCompany(data)
      commit(types.REGISTER_COMPANY_SUCCESS)
    } catch (error) {
      commit(types.REGISTER_COMPANY_ERROR, error)
    }
  }
}

export default actions
